import { render, staticRenderFns } from "./Houseinfo.vue?vue&type=template&id=dead89da&scoped=true&"
import script from "./Houseinfo.vue?vue&type=script&lang=js&"
export * from "./Houseinfo.vue?vue&type=script&lang=js&"
import style0 from "./Houseinfo.vue?vue&type=style&index=0&id=dead89da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dead89da",
  null
  
)

export default component.exports